<template>
  <transition name="fade">
    <section id="addProgram">
      <form @submit.prevent="add">
        <input required placeholder="Program title" type="text" v-model="program.title">
        <input required placeholder="Working Directory" type="text" v-model="program.directory">
        <input required placeholder="Queue Size" type="number" v-model="program.queueSize">
        <input required placeholder="Command line" type="text" v-model="program.command">
        <input placeholder="Options" type="text" v-model="program.options">
        <textarea placeholder="Program description" v-model="program.info"></textarea>
        <div class="checkbox">
          <input type="checkbox" v-model="outFile" id="passkey">
          <label tabindex="0" for="passkey">Outputs to file</label>
        </div>
        <div class="checkbox">
          <input type="checkbox" v-model="exampleInput" id="example">
          <label tabindex="0" for="example">Example Input</label>
        </div>
        <template v-if="outFile">
          <input
            type="text"
            placeholder="Ouput File location"
            v-model="program.outFile.dir"
          >
          <input
            type="text"
            placeholder="Ouput File Extension"
            v-model="program.outFile.ext"
          >
        </template>
        <template v-if="exampleInput">
          <input
            class="link"
            type="text"
            placeholder="Example Input Title"
            v-model="program.exampleInput.title"
          >
          <textarea placeholder="Example Input" v-model="program.exampleInput.input"></textarea>
        </template>
        <input class="link" type="text" placeholder="Link to the paper" v-model="program.link">
        <input required type="password" placeholder="Admin passkey" v-model="program.passkey">
        <button type="submit">Add a new Program</button>
      </form>
    </section>
  </transition>
</template>
<script>
import axios from "axios";
export default {
  name: "addProgram",
  data() {
    return {
      exampleInput: false,
      outFile: false,
      program: {
        title: "",
        directoy: "",
        queueSize: "",
        command: "",
        options: "",
        info: "",
        link: "",
        passkey: "",
        exampleInput: {
          title: "",
          input: ""
        },
        outFile: {
          dir: "",
          ext: ""
        }
      }
    };
  },
  methods: {
    add() {
      axios
        .post(process.env.VUE_APP_API_HOST + "/api/programs", this.program)
        .then(res => {
          console.log(res);
          this.$parent.getPrograms();
        })
        .catch(err => console.log(err));
      this.$parent.toggle_lock();
    }
  }
};
</script>
<style scoped>
#addProgram form {
  clear: right;
  overflow: auto;
}
#addProgram form > input {
  width: calc(50% - 15px);
  margin-right: var(--gap-huge);
  box-sizing: border-box;
  float: left;
}
#addProgram form > input:nth-of-type(3n),
#addProgram form > input:nth-of-type(5n) {
  margin-right: 10px;
}
#addProgram form button {
  width: calc(50% - 20px);
  margin-right: 10px;
}
#addProgram form .checkbox {
  min-height: 40px;
  margin-top: var(--gap);
  margin-bottom: var(--gap-huge);
  float: left;
}
#addProgram form .checkbox:first-of-type {
  margin-right: var(--gap-huge);
}
#addProgram form .link,
#addProgram form textarea,
#addProgram form > input:first-child {
  display: block;
  width: calc(100% - 10px);
  box-sizing: border-box;
}
#addProgram textarea,
#addProgram input {
  border-color: var(--accent-light);
  margin-bottom: var(--gap-huge);
}
</style>
